export const scope = "SelectionManagement";

const DEFAULT_SELECTION_STATE = {
  selectedAccount: null,
  selectedCards: [],
  selectedIndustries: [],
  selectedParticipants: [],
  selectedScripts: [],
  selectedTags: [],
  selectedWords: [],
};

const CreateSelectionManagementStore = (set, get) => ({
  ...DEFAULT_SELECTION_STATE,

  setValue: (key, value) => {
    set(
      (currentState) => ({
        ...currentState,
        [scope]: { ...get()[scope], [key]: value },
      }),
      false,
      `[${scope}.setValue](${key}, ${JSON.stringify(value)}) `,
    );
  },

  resetSelectionStore: () => {
    set(
      (currentState) => ({
        ...currentState,
        [scope]: {
          ...currentState[scope],
          ...DEFAULT_SELECTION_STATE,
        },
      }),
      false,
      `${scope} : resetSelectionStore`,
    );
  },
});

export default CreateSelectionManagementStore;
